import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { cfg } from '@/config'

Vue.use(Vuetify)

export default new Vuetify({ theme: cfg.theme.vuetify })
